module.exports = __webpack_public_path__ + "img/10.4310bebc.svg";